import TableStore from '../../../stores/TableStore';
import { CellLocation } from '../../../stores/types';

export const handleEnter = (cellLocation: CellLocation, tableStore: TableStore) => {
  const { row, column } = cellLocation;
  if (row === tableStore.tableState.length - 1) {
    tableStore.updateCellState('CellFirstSelect', cellLocation);
    return;
  }

  tableStore.resetRowState(row);
  tableStore.setSelectedRow(row + 1);
  tableStore.updateRowState('Highlighted', row + 1);
  tableStore.updateCellState('CellFirstSelect', { row: row + 1, column });
};

// TODO: jump to next cell, first column if tab is triggered from the last column; analogous for left
// TODO: last column, last row / first column, first row => default tab behavior
export const handleTab = (
  event: React.KeyboardEvent<HTMLDivElement | HTMLTextAreaElement>,
  cellLocation: CellLocation,
  tableStore: TableStore,
) => {
  const { row, column } = cellLocation;
  if (column === tableStore.tableState[row].cellStates.length - 1) {
    event.preventDefault();
    tableStore.updateCellState('CellFirstSelect', cellLocation);
    return;
  }

  tableStore.updateRowState('Highlighted', row); // required because blur is fired
  tableStore.setSelectedRow(row); // required because blur is fired
};
